<template>
  <el-dialog
      :visible.sync="visible"
      title="发货单价调整"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"
        :rules="dataRule"
    >
      <el-form-item prop="receiptCode" label="已选择">
       {{dataForm.ids.length}}个
      </el-form-item>
      <el-form-item prop="price" label="发货单价：">
        <el-input v-model="dataForm.price" placeholder="请输入发货单价"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import DictDropdown from '@/components/DictDropdown/index.vue'
import {moneyValidator} from '@/utils/validate'

export default {
  name: 'destination-dialog',
  components: {DictDropdown},
  data () {
    return {
      visible: false,
      dataForm: {
        ids: [],
        price: ''
      },
      dataRule: {
        price: [
          { required: true, message: '请输入发货单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    open (ids) {
      this.visible = true
      this.dataForm.ids = ids
    },
   async dataFormSubmitHandle () {
      const postForm={
        ...this.dataForm
      }
      const res = await this.$api2.post(`/erp/box/detail/change/price`, postForm)
      this.$emit('changed')
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
